<script>
    import {showDialogLogin} from "../../../js/stores";
    import {API_URL} from "../../../../env";
    import {push} from "svelte-spa-router";
    import updateUserData from "../../../js/updateUserData";

    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    let isFetching = false

    let email = ""
    let password = ""

    let emailBad = false
    let passwordBad = false

    let errorReason = ""

    let shouldRedirect = (typeof $showDialogLogin?.data?.redirect === "boolean")? $showDialogLogin.data.redirect : true

    async function login() {
        if (isFetching) return;
        isFetching = true

        emailBad = false
        passwordBad = false

        errorReason = ""

        if (password.length < 8) {
            passwordBad = true
            errorReason = "Príliš krátke heslo"
        }

        if (!emailRegex.test(email)) {
            emailBad = true
            errorReason = "Zlý tvar e-mailu"
        }

        // Test if everything is ok
        if (emailBad || passwordBad) return isFetching = false;

        // Fetch
        const body = {
            email,
            password
        }

        const res = await fetch(API_URL + '/users/login', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        if (res.status === 202) {
            showDialogLogin.set({show: true, type: "emailNotVerified", data: {email: email}});
            isFetching = false
            return
        }
        else if (res.status === 403) {
            emailBad = true
            passwordBad = true
            errorReason = "Zlé prihlasovacie údaje"
            isFetching = false
            return
        }
        else if (!res.ok) {
            addAlert("danger", "Chyba!", "Pri prihlasovaní nastala chyba. Skúste to prosím znova.")
            isFetching = false
            return
        }

        await updateUserData();

        isFetching = false
        showDialogLogin.set({show: false, type: "", data: {}})

        if (shouldRedirect) {
            await push("/ucet")
        }
    }
</script>

<div class="input-group mt-5 mb-3">
    <label for="email">E-mail</label>
    <input class:unfilled={emailBad} id="email" name="email" type="email" bind:value={email} placeholder="E-mail">
</div>
<div class="input-group mb-2">
    <label for="password">Heslo</label>
    <input class:unfilled={passwordBad} id="password" name="password" type="password" bind:value={password} placeholder="Heslo">
</div>

<p class="text-danger text-right">{errorReason}</p>

<div class="d-flex justify-content-center mt-5">
    <button class="btn btn-slate-50" type="button" on:click={login}>
        {#if isFetching}
            <i class="fas fa-fw fa-spinner-third fa-spin mr-2"></i>
        {:else}
            <i class="fas fa-fw fa-user mr-2"></i>
        {/if}
        Prihlásiť sa
    </button>
</div>

<div class="d-flex justify-content-center mt-4">
    <button class="btn btn-link" type="button" on:click={() => showDialogLogin.set({show: true, type: "forgottenPassword"})}>Zabudol si heslo?</button>
</div>